import * as React from "react";
const OneDoorXLSize = ({ isActive = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={71}
    viewBox="0 0 72 71"
    fill={isActive ? "#292747" : "#9493A3"}
    className="gg-scale-[70%] gg-transition gg-duration-150 gg-ease-in-out sm:gg-scale-75 lg:gg-scale-[70%] xl:gg-scale-75 2xl:gg-scale-90"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0v55.43h70V0h-5.06v19H6.06V0zm64.94 21H6.06v29.37h59.88z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.646 67.354a.5.5 0 0 1 0-.708l3.182-3.182a.5.5 0 0 1 .708.707L2.207 66.5h67.586l-2.329-2.329a.5.5 0 1 1 .708-.707l3.182 3.182a.5.5 0 0 1 0 .707l-3.182 3.183a.5.5 0 1 1-.707-.708l2.328-2.328H2.207l2.329 2.328a.5.5 0 1 1-.708.707z"
      fill="#7F7D91"
    />
  </svg>
);
export default OneDoorXLSize;
